import React from 'react';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import { Container, Row, Col } from 'react-bootstrap';

import icon1 from '../assets/images/statistics-icon1.png';
import icon2 from '../assets/images/statistics-icon2.png';
import icon3 from '../assets/images/statistics-icon3.png';
import icon4 from '../assets/images/statistics-icon4.png';

const Statistics = () => {
    const { t } = useTranslation();
    const stats = [
        { icon: icon1, end: 95, suffix: '%', title: t('stats_title1') },
        { icon: icon2, value: '24/7', title: t('stats_title2') },
        { icon: icon3, end: 40, prefix: '+', suffix: '%', title: t('stats_title3') },
        { icon: icon4, end: 10000, prefix: '', suffix: '+', title: t('stats_title4') },
    ];

    return (
        <section className="float-left w-100 statistics-con position-relative padding-top padding-bottom main-box">
            <Container>
                <Row>
                    <Col lg={6} md={6} className="wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s">
                        <div className="statistics-content-con">
                            <div className="heading-title-con mb-0">
                                <span className="special-text color-blue d-block">{t('stats_tag')}</span>
                                <h2 dangerouslySetInnerHTML={{ __html: t('stats_title') }}></h2>
                                <p>{t('stats_desc')}</p>
                                <a href="/about" className="text-decoration-none primary_btn d-inline-block">{t('banner_get_started')}</a>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6} className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.2s">
                        <div className="statistics-outer-con">
                            <Row>
                                {stats.map((stat, index) => (
                                    <Col lg={6} md={6} d-flex key={index}>
                                        <div className="statistics-box w-100">
                                            <figure><img src={stat.icon} alt="icon" className="img-fluid" /></figure>
                                            {stat.end ? (
                                                <CountUp start={0} end={stat.end} duration={2.75} prefix={stat.prefix} suffix={stat.suffix} enableScrollSpy>
                                                    {({ countUpRef }) => <span className="d-inline-block black-text" ref={countUpRef} />}
                                                </CountUp>
                                            ) : (
                                                <span className="d-inline-block black-text">{stat.value}</span>
                                            )}
                                            <sup className="d-inline-block black-text">{stat.suffix}</sup>
                                            <span className="span-text d-block">{stat.title}</span>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Statistics;